import React from "react";
import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Landing from "./pages/Landing";
import SponsorView from "./pages/SponsorView";
import RequestsPage from "./pages/RequestsPage";
import RequestDetail from "./pages/RequestDetail";
import Portfolio from "./pages/Portfolio";
import Diagnostics from "./pages/Diagnostics";
import PublicReceipt from "./pages/PublicReceipt";
import Walkthrough from "./pages/Walkthrough";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/walkthrough" element={<Walkthrough />} />
          <Route path="/sponsor" element={<SponsorView />} />
          <Route path="/requests" element={<RequestsPage />} />
          <Route path="/request/:id" element={<RequestDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/diagnostics" element={<Diagnostics />} />
          <Route path="/r/:hash" element={<PublicReceipt />} />
          <Route path="/receipt/:hash" element={<RedirectToR />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

function RedirectToR() {
  const path = window.location.pathname.replace("/receipt/", "/r/");
  return <Navigate to={path} replace />;
}
